import React, { useState } from 'react';
import './CashCalculatorModal.css';

const CashCalculatorModal = ({ isOpen, onClose, onPaymentComplete, total, currencySymbol }) => {
  const [cashReceived, setCashReceived] = useState('');
  const [isCalculating, setIsCalculating] = useState(false);

  if (!isOpen) return null;

  const calculateChange = () => {
    const received = parseFloat(cashReceived) || 0;
    return received - total;
  };

  const handleNumberInput = (number) => {
    if (cashReceived === '0' || cashReceived === '') {
      setCashReceived(number.toString());
    } else {
      setCashReceived(prev => prev + number.toString());
    }
  };

  const handleDecimal = () => {
    if (!cashReceived.includes('.')) {
      setCashReceived(prev => prev + '.');
    }
  };

  const handleClear = () => {
    setCashReceived('');
  };

  const handleDelete = () => {
    setCashReceived(prev => prev.slice(0, -1));
  };

  const handleExactAmount = () => {
    setCashReceived(total.toFixed(2));
  };

  const handleQuickAmount = (amount) => {
    setCashReceived(amount.toString());
  };

  const handleCompletPayment = () => {
    const received = parseFloat(cashReceived) || 0;
    const change = calculateChange();

    if (received < total) {
      alert('Cash received is less than the total amount!');
      return;
    }

    setIsCalculating(true);
    setTimeout(() => {
      onPaymentComplete(received, change);
      setIsCalculating(false);
      setCashReceived('');
    }, 500);
  };

  const change = calculateChange();
  const isValidPayment = parseFloat(cashReceived) >= total;

  // Quick amount buttons (common Malaysian notes)
  const quickAmounts = [5, 10, 20, 50, 100];

  return (
    <div className="cash-modal-overlay" onClick={onClose}>
      <div className="cash-modal-content" onClick={e => e.stopPropagation()}>
        <div className="cash-modal-header">
          <h3>Cash Payment</h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="cash-summary">
          <div className="total-amount">
            <span>Total Amount:</span>
            <strong>{currencySymbol}{total.toFixed(2)}</strong>
          </div>
        </div>

        <div className="cash-input-section">
          <label className="cash-label">Cash Received:</label>
          <div className="cash-display">
            <span className="currency">{currencySymbol}</span>
            <input 
              type="text" 
              value={cashReceived}
              readOnly
              className="cash-input"
              placeholder="0.00"
            />
          </div>
        </div>

        {cashReceived && (
          <div className="change-display">
            <div className={`change-amount ${change >= 0 ? 'positive' : 'negative'}`}>
              <span>Change:</span>
              <strong>
                {change >= 0 ? 
                  `${currencySymbol}${change.toFixed(2)}` : 
                  `Short: ${currencySymbol}${Math.abs(change).toFixed(2)}`
                }
              </strong>
            </div>
          </div>
        )}

        <div className="quick-amounts">
          <button 
            className="quick-btn exact-btn"
            onClick={handleExactAmount}
          >
            Exact
          </button>
          {quickAmounts.map(amount => (
            <button 
              key={amount}
              className="quick-btn"
              onClick={() => handleQuickAmount(amount)}
            >
              {currencySymbol}{amount}
            </button>
          ))}
        </div>

        <div className="calculator-grid">
          <button className="calc-btn" onClick={() => handleNumberInput(7)}>7</button>
          <button className="calc-btn" onClick={() => handleNumberInput(8)}>8</button>
          <button className="calc-btn" onClick={() => handleNumberInput(9)}>9</button>
          <button className="calc-btn delete-btn" onClick={handleDelete}>
            <i className="fas fa-backspace"></i>
          </button>

          <button className="calc-btn" onClick={() => handleNumberInput(4)}>4</button>
          <button className="calc-btn" onClick={() => handleNumberInput(5)}>5</button>
          <button className="calc-btn" onClick={() => handleNumberInput(6)}>6</button>
          <button className="calc-btn clear-btn" onClick={handleClear}>C</button>

          <button className="calc-btn" onClick={() => handleNumberInput(1)}>1</button>
          <button className="calc-btn" onClick={() => handleNumberInput(2)}>2</button>
          <button className="calc-btn" onClick={() => handleNumberInput(3)}>3</button>
          <button className="calc-btn rowspan-2 confirm-btn" 
                  onClick={handleCompletPayment}
                  disabled={!isValidPayment || isCalculating}>
            {isCalculating ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <>
                <i className="fas fa-check"></i>
                <span>Pay</span>
              </>
            )}
          </button>

          <button className="calc-btn colspan-2" onClick={() => handleNumberInput(0)}>0</button>
          <button className="calc-btn" onClick={handleDecimal}>.</button>
        </div>
      </div>
    </div>
  );
};

export default CashCalculatorModal;